function formatMoney(cents) {
  return "£" + (cents / 100).toFixed(2);
}

let shouldOpenDrawer = false;

function openDrawer() {
  const drawer = document.getElementById("cart-drawer");
  if (!drawer) return;

  drawer.classList.add("open");
  document.documentElement.classList.add("cart-drawer-open");
  document.body.classList.add("cart-drawer-open");
  document.querySelectorAll("[data-cart-drawer-trigger], .js-cart-icon").forEach((trigger) => {
    trigger.setAttribute("aria-expanded", "true");
  });
}

function closeDrawer() {
  const drawer = document.getElementById("cart-drawer");
  if (!drawer) return;

  drawer.classList.remove("open");
  document.documentElement.classList.remove("cart-drawer-open");
  document.body.classList.remove("cart-drawer-open");
  document.querySelectorAll("[data-cart-drawer-trigger], .js-cart-icon").forEach((trigger) => {
    trigger.setAttribute("aria-expanded", "false");
  });
}

window.openCartDrawer = openDrawer;
window.closeCartDrawer = closeDrawer;

async function refreshDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const html = await res.text();
  const dom = new DOMParser().parseFromString(html, "text/html");
  const newPanel = dom.querySelector(".cart-drawer__panel");
  const currentPanel = document.querySelector(".cart-drawer__panel");
  if (newPanel && currentPanel) currentPanel.innerHTML = newPanel.innerHTML;
}

async function loadAiRecommendations() {
  const container = document.querySelector(".cart-ai-recommendations");
  if (!container) return;

  container.innerHTML = "";

  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    if (!cart.items || !cart.items.length) return;

    const orderedCartItems = [...cart.items].reverse();

    const cartHandleSet = new Set(
      orderedCartItems.map((item) => item.handle).filter(Boolean),
    );

    const typeMap = new Map();

    for (const item of orderedCartItems) {
      const handle = item.handle;
      const productType = (item.product_type || "unknown").trim().toLowerCase();

      if (!handle) continue;

      if (!typeMap.has(productType)) {
        typeMap.set(productType, {
          productType,
          sourceHandles: [],
          items: [],
        });
      }

      const group = typeMap.get(productType);

      if (!group.sourceHandles.includes(handle)) {
        group.sourceHandles.push(handle);
      }
    }

    for (const group of typeMap.values()) {
      const seenWithinType = new Set();

      for (const handle of group.sourceHandles) {
        const url = `/products/${handle}?section_id=cart-fbt`;

        try {
          const res = await fetch(url);
          const html = await res.text();

          const doc = new DOMParser().parseFromString(html, "text/html");
          const items = [...doc.querySelectorAll(".cart-ai-item")];

          for (const itemEl of items) {
            const link = itemEl.querySelector(".cart-ai-link");
            if (!link) continue;

            const href = link.getAttribute("href") || "";
            const matchedHandle = href
              .split("/products/")[1]
              ?.split("?")[0]
              ?.split("/")[0];

            if (!matchedHandle) continue;
            if (cartHandleSet.has(matchedHandle)) continue;
            if (seenWithinType.has(matchedHandle)) continue;

            seenWithinType.add(matchedHandle);

            group.items.push({
              handle: matchedHandle,
              html: itemEl.outerHTML,
            });
          }
        } catch (err) {}
      }
    }

    const recommendationBuckets = [...typeMap.values()].filter(
      (group) => group.items.length,
    );

    if (!recommendationBuckets.length) {
      container.innerHTML = "";
      return;
    }

    const usedHandles = new Set(cartHandleSet);
    const finalItems = [];
    const limit = 6;
    let addedInPass = true;

    while (finalItems.length < limit && addedInPass) {
      addedInPass = false;

      for (const bucket of recommendationBuckets) {
        while (bucket.items.length) {
          const candidate = bucket.items.shift();

          if (!candidate?.handle) continue;
          if (usedHandles.has(candidate.handle)) continue;

          usedHandles.add(candidate.handle);
          finalItems.push(candidate);
          addedInPass = true;

          break;
        }

        if (finalItems.length >= limit) break;
      }
    }

    if (!finalItems.length) {
      container.innerHTML = "";
      return;
    }

    container.innerHTML = `
      <div class="cart-fbt-block">
        <p class="cart-fbt-heading">Frequently Bought Together</p>
        <div class="cart-ai-grid">
          ${finalItems.map((item) => item.html).join("")}
        </div>
      </div>
    `;
  } catch (error) {
    container.innerHTML = "";
  }
}

document.addEventListener("click", (e) => {
  if (e.target.closest("[data-cart-drawer-trigger], .js-cart-icon")) {
    e.preventDefault();
    e.stopImmediatePropagation();
    shouldOpenDrawer = true;
    openDrawer();
    setTimeout(() => {
      updateTierIcons();
      updateProgressBar();
    }, 20);
    loadAiRecommendations();
  }
}, true);

document.addEventListener("click", (e) => {
  if (e.target.closest(".cart-drawer__close")) closeDrawer();
  if (e.target.classList.contains("cart-drawer__overlay")) closeDrawer();
});

document.addEventListener("click", (e) => {
  if (e.target.closest(".product-form__submit")) {
    shouldOpenDrawer = true;
  }
});

document.addEventListener("click", (e) => {
  if (e.target.closest(".boost-sd__btn-add-to-cart")) {
    shouldOpenDrawer = true;
    e.preventDefault();
    const btn = e.target.closest(".boost-sd__btn-add-to-cart");
    const variantId = btn.dataset.variantId || btn.getAttribute("data-variant-id");
    if (!variantId) return;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
  }
});

document.addEventListener("click", async (e) => {
  const minus = e.target.closest(".minus");
  const plus = e.target.closest(".plus");
  const remove = e.target.closest(".cart-drawer__remove");
  if (!minus && !plus && !remove) return;

  const item = e.target.closest(".cart-drawer__item");
  const key = item.dataset.key;
  const valueBox = item.querySelector(".qty-value");

  item.classList.add("is-loading");

  let qty = parseInt(valueBox.textContent);
  if (minus) qty = Math.max(0, qty - 1);
  if (plus) qty++;
  if (remove) qty = 0;

  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: key, quantity: qty })
  });

  await refreshDrawer();
  // updateTierIcons();
  // updateProgressBar();
  // maybeTriggerConfetti();
  updateCartCount();
  loadAiRecommendations();
});

const FINAL_TIER = 450000;

function getCartTotalCents() {
  const el = document.getElementById("drawer-original-subtotal");
  return parseInt(el.textContent.replace(/[^0-9]/g, "")) || 0;
}

function updateProgressBar() {
  const total = getCartTotalCents();

  const amounts = [40000,150000,250000,450000];
  const icons = [...document.querySelectorAll(".tier-icon")];
  const bar = document.querySelector(".tier-progress-bar");
  const track = document.querySelector(".tier-progress-inner");

  if (!icons.length || !bar || !track) return;

  const trackRect = track.getBoundingClientRect();
  const iconPositions = icons.map(i => {
    const r = i.getBoundingClientRect();
    return r.left + r.width/2 - trackRect.left;
  });

  let widthPx = 0;

  if (total <= amounts[0]) {
    const percent = total / amounts[0];
    widthPx = iconPositions[0] * percent;
  }
  else if (total <= amounts[1]) {
    const base = iconPositions[0];
    const diff = total - amounts[0];
    const range = amounts[1] - amounts[0];
    const percent = diff / range;
    widthPx = base + (iconPositions[1] - base) * percent;
  }
  else if (total <= amounts[2]) {
    const base = iconPositions[1];
    const diff = total - amounts[1];
    const range = amounts[2] - amounts[1];
    const percent = diff / range;
    widthPx = base + (iconPositions[2] - base) * percent;
  }
  else if (total <= amounts[3]) {
    const base = iconPositions[2];
    const diff = total - amounts[2];
    const range = amounts[3] - amounts[2];
    const percent = diff / range;
    widthPx = base + (iconPositions[3] - base) * percent;
  }
  else {
    widthPx = iconPositions[3];
  }

  bar.style.width = widthPx + "px";
  if (total >= 450000) showConfetti();

}

function maybeTriggerConfetti() {
  const total = getCartTotalCents();
  if (total >= FINAL_TIER) showConfetti();
}

function showConfetti() {
  const animationContainer = document.getElementById("lottie-animation");
  if (!animationContainer) return;

  animationContainer.style.display = "block";

  const animation = lottie.loadAnimation({
    container: animationContainer,
    renderer: "svg",
    loop: false,
    autoplay: true,
    path: "https://lottie.host/7c83192e-2b5a-4159-83ab-71b33eef1511/u2VxttecvO.json"
  });

  setTimeout(() => {
    animationContainer.style.display = "none";
    animation.destroy();
  }, 5000);
}

function updateTierIcons() {
  const total = getCartTotalCents();
  const colored = "https://cdn.shopify.com/s/files/1/0565/3771/0697/files/Frame_38965_1.svg?v=1696663751";
  const nonColored = "https://cdn.shopify.com/s/files/1/0565/3771/0697/files/Frame_38966_1.svg?v=1696663480";

  document.querySelectorAll(".tier-icon").forEach(icon => {
    const tierValue = parseInt(icon.dataset.tier);
    const img = icon.querySelector(".tier-icon-img");
    img.src = total >= tierValue ? colored : nonColored;
  });
  if (total >= 450000) showConfetti();

}

async function updateCartCount() {
  const res = await fetch("/cart.js");
  const data = await res.json();
  const el = document.getElementById("cart-svg-count");
  if (el) el.textContent = data.item_count;
}

(function () {
  const originalFetch = window.fetch;
  window.fetch = async function (url, options) {
    const response = await originalFetch(url, options);
    const requestUrl = typeof url === "string" ? url : url?.url;
    if (requestUrl?.includes("/cart/add") && shouldOpenDrawer) {
      await refreshDrawer();
      openDrawer();
      // updateTierIcons();
      // updateProgressBar();
      // maybeTriggerConfetti();
      updateCartCount();
      loadAiRecommendations();
      shouldOpenDrawer = false;
    }
    return response;
  };
})();

window.addEventListener("resize", () => {
  setTimeout(updateProgressBar, 300);
});

document.addEventListener("click", (e) => {
  const toggle = e.target.closest(".cart-more-toggle");
  if (!toggle) return;

  const content = document.querySelector(".cart-more-content");

  toggle.classList.toggle("open");
  content.classList.toggle("open");
});
